module.exports = __webpack_public_path__ + "img/jpeg.c6ebc6ba.svg";